export const categories = [
  {
    slug: 'rumen',
    name: '入门指南',
    description: '从零开始，快速上手爱液网页版的基础操作与功能介绍',
    icon: 'ri-guide-line',
    count: 3,
  },
  {
    slug: 'jiqiao',
    name: '使用技巧',
    description: '深度挖掘爱液网页版的隐藏功能与高效操作技巧',
    icon: 'ri-lightbulb-line',
    count: 2,
  },
  {
    slug: 'gengxin',
    name: '版本更新',
    description: '第一时间了解爱液网页版的最新功能与版本动态',
    icon: 'ri-rocket-line',
    count: 1,
  },
  {
    slug: 'wenti',
    name: '常见问题',
    description: '解答用户在使用爱液网页版过程中遇到的各种疑问',
    icon: 'ri-question-answer-line',
    count: 1,
  },
  {
    slug: 'anquan',
    name: '安全与隐私',
    description: '了解爱液网页版如何保护您的数据安全与个人隐私',
    icon: 'ri-shield-check-line',
    count: 1,
  },
  {
    slug: 'duan',
    name: '多端使用',
    description: 'PC端、手机端、平板端——爱液网页版全平台适配指南',
    icon: 'ri-device-line',
    count: 2,
  },
];